import Tooltip from '@mui/material/Tooltip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import { TooltipMessages, UISubmissionStatus, UISubmissionStatusLabels } from '@ifa/types';

const iconStyles = {
    verticalAlign: 'middle',
    marginRight: '0.5rem',
    fontSize: '1.15rem',
};

function StatusLabel({ status }: { status: UISubmissionStatus }) {
    return (
        <Typography variant="body1" component="span" textTransform="capitalize" color="inherit" fontSize="inherit">
            {UISubmissionStatusLabels[status]}
        </Typography>
    );
}

function DashboardTableStatus({ status }: { status: UISubmissionStatus }) {
    const completedCondition = status === 'READY';
    const errorCondition = status === 'ERROR' || status === 'FAILED';
    const pendingCondition = status === 'RECEIVED' || status === 'PROCESSING';

    return (
        <Box display="flex" alignContent="center">
            <Tooltip title={TooltipMessages[status]} placement="left" arrow>
                <Box display="flex" alignItems="center" data-cy={`status-${status.toLowerCase()}`}>
                    {errorCondition && <ErrorIcon color="error" sx={iconStyles} />}
                    {pendingCondition && <PendingIcon color="primary" sx={iconStyles} />}
                    {completedCondition && <CheckCircleIcon color="success" sx={iconStyles} />}
                    <StatusLabel status={status} />
                </Box>
            </Tooltip>
        </Box>
    );
}

export default DashboardTableStatus;
